/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function BanIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M28.063 30.219 9.75 11.906A13.1 13.1 0 0 0 7 19.97c0 7.187 5.813 13 13 13 3 0 5.813-1 8.063-2.75m2.125-2.125C31.938 25.844 33 23.03 33 19.969c0-7.125-5.875-13-13-13-3.062 0-5.875 1.062-8.125 2.812zM4 19.969C4 14.28 7 9.03 12 6.156c4.938-2.875 11-2.875 16 0 4.938 2.875 8 8.125 8 13.813 0 5.75-3.062 11-8 13.875-5 2.875-11.062 2.875-16 0-5-2.875-8-8.125-8-13.875"/>}
        </IconWrapper>);
}
